export default {
  pages: {
    key: "title",
    data: [
      {title: 'Interventions',   url: '/interventions', icon: 'ToolIcon', is_bookmarked: false},
      {title: 'Créer intervention',   url: '/intervention', icon: 'ToolIcon', is_bookmarked: true},
      {title: 'Artisans', url: '/artisans', icon: 'UserIcon', is_bookmarked: false},
      {title: 'Clients', url: '/clients', icon: 'UsersIcon', is_bookmarked: false},
      {title: 'Agenda', url: '/agenda', icon: 'CalendarIcon', is_bookmarked: false},
      {title: 'Factures', url: '/factures', icon: 'FileTextIcon', is_bookmarked: false},
      {title: 'Devis', url: '/devis', icon: 'FileTextIcon', is_bookmarked: false},
      {title: 'Produits', url: '/produits', icon: 'ClipboardIcon', is_bookmarked: false},
    ]
  }
}
